// extracted by mini-css-extract-plugin
module.exports = {"container":"lAcX7","card":"n5jjt","info":"_9isUg","distance":"w6JzF","address":"I3zE0","order-button":"FkJWW"};